export const COLOUR_KEYS = [
  {
    key: 'background',
    label: 'Background',
    description: 'Background color for the body and other primary surfaces. (Default Value: #fff)',
    defaultValue: '#fff',
  },
  {
    key: 'foreground',
    label: 'Foreground',
    description: 'Default text and foreground color for the body. (Default Value: #000)',
    defaultValue: '#000',
  },
  {
    key: 'muted',
    label: 'Muted',
    description: 'Muted background color for elements like cards or sidebars. (Default Value: #f7f7f7)',
    defaultValue: '#f7f7f7',
  },
  {
    key: 'muted-foreground',
    label: 'Muted Foreground',
    description: 'Muted foreground color for less prominent text. (Default Value: #8e8e8e)',
    defaultValue: '#8e8e8e',
  },
  {
    key: 'accent',
    label: 'Accent',
    description: 'Accent color for visually highlighting interactive elements. (Default Value: #f7f7f7)',
    defaultValue: '#f7f7f7',
  },
  {
    key: 'accent-foreground',
    label: 'Accent Foreground',
    description: 'Text color to be used on top of accent backgrounds. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
  {
    key: 'destructive',
    label: 'Destructive',
    description: 'Color for elements that indicate a destructive action, like a delete button. (Default Value: #e4572e)',
    defaultValue: '#e4572e',
  },
  {
    key: 'primary',
    label: 'Primary',
    description: 'The primary brand color, used for main call-to-action buttons and links. (Default Value: #4f5cff)',
    defaultValue: '#4f5cff',
  },
  {
    key: 'primary-foreground',
    label: 'Primary Foreground',
    description: 'Text color to be used on top of primary backgrounds. (Default Value: #fcfcfc)',
    defaultValue: '#fcfcfc',
  },
  {
    key: 'secondary',
    label: 'Secondary',
    description: 'The secondary brand color, used for less prominent elements. (Default Value: #ffe08a)',
    defaultValue: '#ffe08a',
  },
  {
    key: 'secondary-foreground',
    label: 'Secondary Foreground',
    description: 'Text color to be used on top of secondary backgrounds. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
  {
    key: 'tertiary',
    label: 'Tertiary',
    description: 'The tertiary brand color, for alternative accents. (Default Value: #e6b17e)',
    defaultValue: '#e6b17e',
  },
  {
    key: 'tertiary-foreground',
    label: 'Tertiary Foreground',
    description: 'Text color to be used on top of tertiary backgrounds. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
  {
    key: 'quaternary',
    label: 'Quaternary',
    description: 'The quaternary brand color. (Default Value: #eaffea)',
    defaultValue: '#eaffea',
  },
  {
    key: 'quaternary-foreground',
    label: 'Quaternary Foreground',
    description: 'Text color to be used on top of quaternary backgrounds. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
  {
    key: 'quinary',
    label: 'Quinary',
    description: 'The quinary brand color. (Default Value: #fffbe6)',
    defaultValue: '#fffbe6',
  },
  {
    key: 'quinary-foreground',
    label: 'Quinary Foreground',
    description: 'Text color to be used on top of quinary backgrounds. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
  {
    key: 'senary',
    label: 'Senary',
    description: 'The senary brand color. (Default Value: #ffeaf6)',
    defaultValue: '#ffeaf6',
  },
  {
    key: 'senary-foreground',
    label: 'Senary Foreground',
    description: 'Text color to be used on top of senary backgrounds. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
  {
    key: 'septenary',
    label: 'Septenary',
    description: 'The septenary brand color. (Default Value: #f3eaff)',
    defaultValue: '#f3eaff',
  },
  {
    key: 'septenary-foreground',
    label: 'Septenary Foreground',
    description: 'Text color to be used on top of septenary backgrounds. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
];

export const FONT_KEYS = [
  {
    key: 'font-sans-family',
    label: 'Font Sans Family',
    description: 'Uploaded fonts will be used instead of the ones declared here.',
    defaultValue:
      "ui-sans-serif, system-ui, sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  },
  {
    key: 'font-serif-family',
    label: 'Font Serif Family',
    description: 'Uploaded fonts will be used instead of the ones declared here.',
    defaultValue: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif",
  },
  {
    key: 'font-mono-family',
    label: 'Font Mono Family',
    description: 'Uploaded fonts will be used instead of the ones declared here.',
    defaultValue: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
  },
  {
    key: 'font-weight-thin',
    label: 'Font Weight Thin',
    description: 'Controls the font weight for "thin" text. (Default Value: 100)',
    defaultValue: '100',
  },
  {
    key: 'font-weight-extralight',
    label: 'Font Weight Extralight',
    description: 'Controls the font weight for "extralight" text. (Default Value: 200)',
    defaultValue: '200',
  },
  {
    key: 'font-weight-light',
    label: 'Font Weight Light',
    description: 'Controls the font weight for "light" text. (Default Value: 300)',
    defaultValue: '300',
  },
  {
    key: 'font-weight-normal',
    label: 'Font Weight Normal',
    description: 'Controls the font weight for "normal" text. (Default Value: 400)',
    defaultValue: '400',
  },
  {
    key: 'font-weight-medium',
    label: 'Font Weight Medium',
    description: 'Controls the font weight for "medium" text. (Default Value: 500)',
    defaultValue: '500',
  },
  {
    key: 'font-weight-semibold',
    label: 'Font Weight Semibold',
    description: 'Controls the font weight for "semibold" text. (Default Value: 600)',
    defaultValue: '600',
  },
  {
    key: 'font-weight-bold',
    label: 'Font Weight Bold',
    description: 'Controls the font weight for "bold" text. (Default Value: 700)',
    defaultValue: '700',
  },
  {
    key: 'font-weight-extrabold',
    label: 'Font Weight Extrabold',
    description: 'Controls the font weight for "extrabold" text. (Default Value: 800)',
    defaultValue: '800',
  },
  {
    key: 'font-weight-black',
    label: 'Font Weight Black',
    description: 'Controls the font weight for "black" text. (Default Value: 900)',
    defaultValue: '900',
  },
];

export const TEXT_KEYS = [
  {
    key: 'text-xs',
    label: 'Text XS',
    description: 'Controls the font size for extra-small text. (Default Value: 0.75rem)',
    defaultValue: '0.75rem',
  },
  {
    key: 'text-xs--line-height',
    label: 'Text XS Line Height',
    description: 'Controls the line height for extra-small text. (Default Value: 1rem)',
    defaultValue: '1rem',
  },
  {
    key: 'text-sm',
    label: 'Text SM',
    description: 'Controls the font size for small text. (Default Value: 0.875rem)',
    defaultValue: '0.875rem',
  },
  {
    key: 'text-sm--line-height',
    label: 'Text SM Line Height',
    description: 'Controls the line height for small text. (Default Value: 1.25rem)',
    defaultValue: '1.25rem',
  },
  {
    key: 'text-base',
    label: 'Text Base',
    description: 'Controls the base font size for the document. (Default Value: 1rem)',
    defaultValue: '1rem',
  },
  {
    key: 'text-base--line-height',
    label: 'Text Base Line Height',
    description: 'Controls the line height for base text. (Default Value: 1.5rem)',
    defaultValue: '1.5rem',
  },
  {
    key: 'text-lg',
    label: 'Text LG',
    description: 'Controls the font size for large text. (Default Value: 1.125rem)',
    defaultValue: '1.125rem',
  },
  {
    key: 'text-lg--line-height',
    label: 'Text LG Line Height',
    description: 'Controls the line height for large text. (Default Value: 1.75rem)',
    defaultValue: '1.75rem',
  },
  {
    key: 'text-xl',
    label: 'Text XL',
    description: 'Controls the font size for extra-large text. (Default Value: 1.25rem)',
    defaultValue: '1.25rem',
  },
  {
    key: 'text-xl--line-height',
    label: 'Text XL Line Height',
    description: 'Controls the line height for extra-large text. (Default Value: 1.75rem)',
    defaultValue: '1.75rem',
  },
  {
    key: 'text-2xl',
    label: 'Text 2XL',
    description: 'Controls the font size for 2XL text. (Default Value: 1.5rem)',
    defaultValue: '1.5rem',
  },
  {
    key: 'text-2xl--line-height',
    label: 'Text 2XL Line Height',
    description: 'Controls the line height for 2XL text. (Default Value: 2rem)',
    defaultValue: '2rem',
  },
  {
    key: 'text-3xl',
    label: 'Text 3XL',
    description: 'Controls the font size for 3XL text. (Default Value: 1.875rem)',
    defaultValue: '1.875rem',
  },
  {
    key: 'text-3xl--line-height',
    label: 'Text 3XL Line Height',
    description: 'Controls the line height for 3XL text. (Default Value: 2.25rem)',
    defaultValue: '2.25rem',
  },
  {
    key: 'text-4xl',
    label: 'Text 4XL',
    description: 'Controls the font size for 4XL text. (Default Value: 2.25rem)',
    defaultValue: '2.25rem',
  },
  {
    key: 'text-4xl--line-height',
    label: 'Text 4XL Line Height',
    description: 'Controls the line height for 4XL text. (Default Value: 2.5rem)',
    defaultValue: '2.5rem',
  },
  {
    key: 'text-5xl',
    label: 'Text 5XL',
    description: 'Controls the font size for 5XL text. (Default Value: 3rem)',
    defaultValue: '3rem',
  },
  {
    key: 'text-5xl--line-height',
    label: 'Text 5XL Line Height',
    description: 'Controls the line height for 5XL text. (Default Value: 1)',
    defaultValue: '1',
  },
  {
    key: 'text-6xl',
    label: 'Text 6XL',
    description: 'Controls the font size for 6XL text. (Default Value: 3.75rem)',
    defaultValue: '3.75rem',
  },
  {
    key: 'text-6xl--line-height',
    label: 'Text 6XL Line Height',
    description: 'Controls the line height for 6XL text. (Default Value: 1)',
    defaultValue: '1',
  },
  {
    key: 'text-7xl',
    label: 'Text 7XL',
    description: 'Controls the font size for 7XL text. (Default Value: 4.5rem)',
    defaultValue: '4.5rem',
  },
  {
    key: 'text-7xl--line-height',
    label: 'Text 7XL Line Height',
    description: 'Controls the line height for 7XL text. (Default Value: 1)',
    defaultValue: '1',
  },
  {
    key: 'text-8xl',
    label: 'Text 8XL',
    description: 'Controls the font size for 8XL text. (Default Value: 6rem)',
    defaultValue: '6rem',
  },
  {
    key: 'text-8xl--line-height',
    label: 'Text 8XL Line Height',
    description: 'Controls the line height for 8XL text. (Default Value: 1)',
    defaultValue: '1',
  },
  {
    key: 'text-9xl',
    label: 'Text 9XL',
    description: 'Controls the font size for 9XL text. (Default Value: 8rem)',
    defaultValue: '8rem',
  },
  {
    key: 'text-9xl--line-height',
    label: 'Text 9XL Line Height',
    description: 'Controls the line height for 9XL text. (Default Value: 1)',
    defaultValue: '1',
  },
];

export const CONTAINER_KEYS = [
  {
    key: 'container-3xs',
    label: 'Container 3XS',
    description: 'Defines the max-width for a 3x extra-small container. (Default Value: 16rem)',
    defaultValue: '16rem',
  },
  {
    key: 'container-2xs',
    label: 'Container 2XS',
    description: 'Defines the max-width for a 2x extra-small container. (Default Value: 18rem)',
    defaultValue: '18rem',
  },
  {
    key: 'container-xs',
    label: 'Container XS',
    description: 'Defines the max-width for an extra-small container. (Default Value: 20rem)',
    defaultValue: '20rem',
  },
  {
    key: 'container-sm',
    label: 'Container SM',
    description: 'Defines the max-width for a small container. (Default Value: 24rem)',
    defaultValue: '24rem',
  },
  {
    key: 'container-md',
    label: 'Container MD',
    description: 'Defines the max-width for a medium container. (Default Value: 28rem)',
    defaultValue: '28rem',
  },
  {
    key: 'container-lg',
    label: 'Container LG',
    description: 'Defines the max-width for a large container. (Default Value: 32rem)',
    defaultValue: '32rem',
  },
  {
    key: 'container-xl',
    label: 'Container XL',
    description: 'Defines the max-width for an extra-large container. (Default Value: 36rem)',
    defaultValue: '36rem',
  },
  {
    key: 'container-2xl',
    label: 'Container 2XL',
    description: 'Defines the max-width for a 2x extra-large container. (Default Value: 42rem)',
    defaultValue: '42rem',
  },
  {
    key: 'container-3xl',
    label: 'Container 3XL',
    description: 'Defines the max-width for a 3x extra-large container. (Default Value: 48rem)',
    defaultValue: '48rem',
  },
  {
    key: 'container-4xl',
    label: 'Container 4XL',
    description: 'Defines the max-width for a 4x extra-large container. (Default Value: 56rem)',
    defaultValue: '56rem',
  },
  {
    key: 'container-5xl',
    label: 'Container 5XL',
    description: 'Defines the max-width for a 5x extra-large container. (Default Value: 64rem)',
    defaultValue: '64rem',
  },
  {
    key: 'container-6xl',
    label: 'Container 6XL',
    description: 'Defines the max-width for a 6x extra-large container. (Default Value: 72rem)',
    defaultValue: '72rem',
  },
  {
    key: 'container-7xl',
    label: 'Container 7XL',
    description: 'Defines the max-width for a 7x extra-large container. (Default Value: 80rem)',
    defaultValue: '80rem',
  },
];

export const SPACING_KEYS = [
  {
    key: 'tracking-tighter',
    label: 'Tracking Tighter',
    description: 'Controls the letter-spacing of text. (Default Value: -0.05em)',
    defaultValue: '-0.05em',
  },
  {
    key: 'tracking-tight',
    label: 'Tracking Tight',
    description: 'Controls the letter-spacing of text. (Default Value: -0.025em)',
    defaultValue: '-0.025em',
  },
  {
    key: 'tracking-normal',
    label: 'Tracking Normal',
    description: 'Controls the letter-spacing of text. (Default Value: 0em)',
    defaultValue: '0em',
  },
  {
    key: 'tracking-wide',
    label: 'Tracking Wide',
    description: 'Controls the letter-spacing of text. (Default Value: 0.025em)',
    defaultValue: '0.025em',
  },
  {
    key: 'tracking-wider',
    label: 'Tracking Wider',
    description: 'Controls the letter-spacing of text. (Default Value: 0.05em)',
    defaultValue: '0.05em',
  },
  {
    key: 'tracking-widest',
    label: 'Tracking Widest',
    description: 'Controls the letter-spacing of text. (Default Value: 0.1em)',
    defaultValue: '0.1em',
  },
  {
    key: 'leading-tight',
    label: 'Leading Tight',
    description: 'Controls the line-height of text. (Default Value: 1.25)',
    defaultValue: '1.25',
  },
  {
    key: 'leading-snug',
    label: 'Leading Snug',
    description: 'Controls the line-height of text. (Default Value: 1.375)',
    defaultValue: '1.375',
  },
  {
    key: 'leading-normal',
    label: 'Leading Normal',
    description: 'Controls the line-height of text. (Default Value: 1.5)',
    defaultValue: '1.5',
  },
  {
    key: 'leading-relaxed',
    label: 'Leading Relaxed',
    description: 'Controls the line-height of text. (Default Value: 1.625)',
    defaultValue: '1.625',
  },
  {
    key: 'leading-loose',
    label: 'Leading Loose',
    description: 'Controls the line-height of text. (Default Value: 2)',
    defaultValue: '2',
  },
];

export const RADIUS_KEYS = [
  {
    key: 'radius-xs',
    label: 'Radius XS',
    description: 'Controls the border-radius of an element. (Default Value: 0.125rem)',
    defaultValue: '0.125rem',
  },
  {
    key: 'radius-sm',
    label: 'Radius SM',
    description: 'Controls the border-radius of an element. (Default Value: 0.25rem)',
    defaultValue: '0.25rem',
  },
  {
    key: 'radius-md',
    label: 'Radius MD',
    description: 'Controls the border-radius of an element. (Default Value: 0.375rem)',
    defaultValue: '0.375rem',
  },
  {
    key: 'radius-lg',
    label: 'Radius LG',
    description: 'Controls the border-radius of an element. (Default Value: 0.5rem)',
    defaultValue: '0.5rem',
  },
  {
    key: 'radius-xl',
    label: 'Radius XL',
    description: 'Controls the border-radius of an element. (Default Value: 0.75rem)',
    defaultValue: '0.75rem',
  },
  {
    key: 'radius-2xl',
    label: 'Radius 2XL',
    description: 'Controls the border-radius of an element. (Default Value: 1rem)',
    defaultValue: '1rem',
  },
  {
    key: 'radius-3xl',
    label: 'Radius 3XL',
    description: 'Controls the border-radius of an element. (Default Value: 1.5rem)',
    defaultValue: '1.5rem',
  },
  {
    key: 'radius-4xl',
    label: 'Radius 4XL',
    description: 'Controls the border-radius of an element. (Default Value: 2rem)',
    defaultValue: '2rem',
  },
];

export const SHADOW_KEYS = [
  {
    key: 'shadow-2xs',
    label: 'Shadow 2XS',
    description: 'Defines the properties for a 2x extra-small box-shadow. (Default Value: 0 1px rgb(0 0 0 / 0.05)) Leave blank to use the default value.',
    defaultValue: '0 1px rgb(0 0 0 / 0.05)',
  },
  {
    key: 'shadow-xs',
    label: 'Shadow XS',
    description: 'Defines the properties for an extra-small box-shadow. (Default Value: 0 1px 2px 0 rgb(0 0 0 / 0.05)) Leave blank to use the default value.',
    defaultValue: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  },
  {
    key: 'shadow-sm',
    label: 'Shadow SM',
    description:
      'Defines the properties for a small box-shadow. (Default Value: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)) Leave blank to use the default value.',
    defaultValue: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  },
  {
    key: 'shadow-md',
    label: 'Shadow MD',
    description:
      'Defines the properties for a medium box-shadow. (Default Value: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)) Leave blank to use the default value.',
    defaultValue: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  },
  {
    key: 'shadow-lg',
    label: 'Shadow LG',
    description:
      'Defines the properties for a large box-shadow. (Default Value: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)) Leave blank to use the default value.',
    defaultValue: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  },
  {
    key: 'shadow-xl',
    label: 'Shadow XL',
    description:
      'Defines the properties for an extra-large box-shadow. (Default Value: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)) Leave blank to use the default value.',
    defaultValue: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },
  {
    key: 'shadow-2xl',
    label: 'Shadow 2XL',
    description:
      'Defines the properties for a 2x extra-large box-shadow. (Default Value: 0 25px 50px -12px rgb(0 0 0 / 0.25)) Leave blank to use the default value.',
    defaultValue: '0 25px 50px -12px rgb(0 0 0 / 0.25)',
  },
  {
    key: 'inset-shadow-2xs',
    label: 'Inset Shadow 2XS',
    description:
      'Defines the properties for a 2x extra-small inset box-shadow. (Default Value: inset 0 1px rgb(0 0 0 / 0.05)) Leave blank to use the default value.',
    defaultValue: 'inset 0 1px rgb(0 0 0 / 0.05)',
  },
  {
    key: 'inset-shadow-xs',
    label: 'Inset Shadow XS',
    description:
      'Defines the properties for an extra-small inset box-shadow. (Default Value: inset 0 1px 1px rgb(0 0 0 / 0.05)) Leave blank to use the default value.',
    defaultValue: 'inset 0 1px 1px rgb(0 0 0 / 0.05)',
  },
  {
    key: 'inset-shadow-sm',
    label: 'Inset Shadow SM',
    description:
      'Defines the properties for a small inset box-shadow. (Default Value: inset 0 2px 4px rgb(0 0 0 / 0.05)) Leave blank to use the default value.',
    defaultValue: 'inset 0 2px 4px rgb(0 0 0 / 0.05)',
  },
  {
    key: 'drop-shadow-xs',
    label: 'Drop Shadow XS',
    description:
      'Defines the properties for an extra-small drop-shadow filter. (Default Value: 0 1px 1px rgb(0 0 0 / 0.05)) Leave blank to use the default value.',
    defaultValue: '0 1px 1px rgb(0 0 0 / 0.05)',
  },
  {
    key: 'drop-shadow-sm',
    label: 'Drop Shadow SM',
    description: 'Defines the properties for a small drop-shadow filter. (Default Value: 0 1px 2px rgb(0 0 0 / 0.15)) Leave blank to use the default value.',
    defaultValue: '0 1px 2px rgb(0 0 0 / 0.15)',
  },
  {
    key: 'drop-shadow-md',
    label: 'Drop Shadow MD',
    description: 'Defines the properties for a medium drop-shadow filter. (Default Value: 0 3px 3px rgb(0 0 0 / 0.12)) Leave blank to use the default value.',
    defaultValue: '0 3px 3px rgb(0 0 0 / 0.12)',
  },
  {
    key: 'drop-shadow-lg',
    label: 'Drop Shadow LG',
    description: 'Defines the properties for a large drop-shadow filter. (Default Value: 0 4px 4px rgb(0 0 0 / 0.15)) Leave blank to use the default value.',
    defaultValue: '0 4px 4px rgb(0 0 0 / 0.15)',
  },
  {
    key: 'drop-shadow-xl',
    label: 'Drop Shadow XL',
    description:
      'Defines the properties for an extra-large drop-shadow filter. (Default Value: 0 9px 7px rgb(0 0 0 / 0.1)) Leave blank to use the default value.',
    defaultValue: '0 9px 7px rgb(0 0 0 / 0.1)',
  },
  {
    key: 'drop-shadow-2xl',
    label: 'Drop Shadow 2XL',
    description:
      'Defines the properties for a 2x extra-large drop-shadow filter. (Default Value: 0 25px 25px rgb(0 0 0 / 0.15)) Leave blank to use the default value.',
    defaultValue: '0 25px 25px rgb(0 0 0 / 0.15)',
  },
];

export const BLUR_KEYS = [
  {
    key: 'blur-xs',
    label: 'Blur XS',
    description: 'Defines the blur amount for an extra-small blur filter. (Default Value: 4px)',
    defaultValue: '4px',
  },
  {
    key: 'blur-sm',
    label: 'Blur SM',
    description: 'Defines the blur amount for a small blur filter. (Default Value: 8px)',
    defaultValue: '8px',
  },
  {
    key: 'blur-md',
    label: 'Blur MD',
    description: 'Defines the blur amount for a medium blur filter. (Default Value: 12px)',
    defaultValue: '12px',
  },
  {
    key: 'blur-lg',
    label: 'Blur LG',
    description: 'Defines the blur amount for a large blur filter. (Default Value: 16px)',
    defaultValue: '16px',
  },
  {
    key: 'blur-xl',
    label: 'Blur XL',
    description: 'Defines the blur amount for an extra-large blur filter. (Default Value: 24px)',
    defaultValue: '24px',
  },
  {
    key: 'blur-2xl',
    label: 'Blur 2XL',
    description: 'Defines the blur amount for a 2x extra-large blur filter. (Default Value: 40px)',
    defaultValue: '40px',
  },
  {
    key: 'blur-3xl',
    label: 'Blur 3XL',
    description: 'Defines the blur amount for a 3x extra-large blur filter. (Default Value: 64px)',
    defaultValue: '64px',
  },
];

export const MISC_KEYS = [
  {
    key: 'card',
    label: 'Card',
    description: 'Background color for card components. (Default Value: #ffffff)',
    defaultValue: '#ffffff',
  },
  {
    key: 'card-foreground',
    label: 'Card Foreground',
    description: 'Foreground text color for card components. (Default Value: #262626)',
    defaultValue: '#262626',
  },
  {
    key: 'popover',
    label: 'Popover',
    description: 'Background color for popover components. (Default Value: #ffffff)',
    defaultValue: '#ffffff',
  },
  {
    key: 'popover-foreground',
    label: 'Popover Foreground',
    description: 'Foreground text color for popover components. (Default Value: #262626)',
    defaultValue: '#262626',
  },
  {
    key: 'border',
    label: 'Border',
    description: 'Default border color for elements like inputs and cards. (Default Value: #ebebeb)',
    defaultValue: '#ebebeb',
  },
  {
    key: 'input',
    label: 'Input',
    description: 'Border color for form inputs. (Default Value: #ebebeb)',
    defaultValue: '#ebebeb',
  },
  {
    key: 'ring',
    label: 'Ring',
    description: 'Color for focus rings on interactive elements. (Default Value: #b3b3b3)',
    defaultValue: '#b3b3b3',
  },
  {
    key: 'chart-1',
    label: 'Chart 1',
    description: 'Primary color for charts and data visualizations. (Default Value: #e6b17e)',
    defaultValue: '#e6b17e',
  },
  {
    key: 'chart-2',
    label: 'Chart 2',
    description: 'Secondary color for charts and data visualizations. (Default Value: #7fd6e6)',
    defaultValue: '#7fd6e6',
  },
  {
    key: 'chart-3',
    label: 'Chart 3',
    description: 'Tertiary color for charts and data visualizations. (Default Value: #5e6be6)',
    defaultValue: '#5e6be6',
  },
  {
    key: 'chart-4',
    label: 'Chart 4',
    description: 'Quaternary color for charts and data visualizations. (Default Value: #eaffea)',
    defaultValue: '#eaffea',
  },
  {
    key: 'chart-5',
    label: 'Chart 5',
    description: 'Quinary color for charts and data visualizations. (Default Value: #fffbe6)',
    defaultValue: '#fffbe6',
  },
  {
    key: 'sidebar',
    label: 'Sidebar',
    description: 'Background color for sidebar components. (Default Value: #fcfcfc)',
    defaultValue: '#fcfcfc',
  },
  {
    key: 'sidebar-foreground',
    label: 'Sidebar Foreground',
    description: 'Foreground text color for sidebar components. (Default Value: #262626)',
    defaultValue: '#262626',
  },
  {
    key: 'sidebar-primary',
    label: 'Sidebar Primary',
    description: 'Primary color for active or highlighted items in the sidebar. (Default Value: #4f5cff)',
    defaultValue: '#4f5cff',
  },
  {
    key: 'sidebar-primary-foreground',
    label: 'Sidebar Primary Foreground',
    description: 'Text color for primary items in the sidebar. (Default Value: #fcfcfc)',
    defaultValue: '#fcfcfc',
  },
  {
    key: 'sidebar-accent',
    label: 'Sidebar Accent',
    description: 'Accent color for sidebar elements. (Default Value: #f7f7f7)',
    defaultValue: '#f7f7f7',
  },
  {
    key: 'sidebar-accent-foreground',
    label: 'Sidebar Accent Foreground',
    description: 'Text color for accent elements in the sidebar. (Default Value: #2e2e2e)',
    defaultValue: '#2e2e2e',
  },
  {
    key: 'sidebar-border',
    label: 'Sidebar Border',
    description: 'Border color for the sidebar. (Default Value: #ebebeb)',
    defaultValue: '#ebebeb',
  },
  {
    key: 'sidebar-ring',
    label: 'Sidebar Ring',
    description: 'Focus ring color for items within the sidebar. (Default Value: #b3b3b3)',
    defaultValue: '#b3b3b3',
  },
];

export const STYLES = {
  colours: {
    background: '',
    foreground: '',
    destructive: '',
    muted: '',
    'muted-foreground': '',
    accent: '',
    'accent-foreground': '',
    primary: '',
    'primary-foreground': '',
    secondary: '',
    'secondary-foreground': '',
    tertiary: '',
    'tertiary-foreground': '',
    quaternary: '',
    'quaternary-foreground': '',
    quinary: '',
    'quinary-foreground': '',
    senary: '',
    'senary-foreground': '',
    septenary: '',
    'septenary-foreground': '',
  },
  fonts: {
    'font-sans-family': '',
    'font-serif-family': '',
    'font-mono-family': '',
    'font-weight-thin': '',
    'font-weight-extralight': '',
    'font-weight-light': '',
    'font-weight-normal': '',
    'font-weight-medium': '',
    'font-weight-semibold': '',
    'font-weight-bold': '',
    'font-weight-extrabold': '',
    'font-weight-black': '',
  },
  texts: {
    'text-xs': '',
    'text-xs--line-height': '',
    'text-sm': '',
    'text-sm--line-height': '',
    'text-base': '',
    'text-base--line-height': '',
    'text-lg': '',
    'text-lg--line-height': '',
    'text-xl': '',
    'text-xl--line-height': '',
    'text-2xl': '',
    'text-2xl--line-height': '',
    'text-3xl': '',
    'text-3xl--line-height': '',
    'text-4xl': '',
    'text-4xl--line-height': '',
    'text-5xl': '',
    'text-5xl--line-height': '',
    'text-6xl': '',
    'text-6xl--line-height': '',
    'text-7xl': '',
    'text-7xl--line-height': '',
    'text-8xl': '',
    'text-8xl--line-height': '',
    'text-9xl': '',
    'text-9xl--line-height': '',
  },
  containers: {
    'container-3xs': '',
    'container-2xs': '',
    'container-xs': '',
    'container-sm': '',
    'container-md': '',
    'container-lg': '',
    'container-xl': '',
    'container-2xl': '',
    'container-3xl': '',
    'container-4xl': '',
    'container-5xl': '',
    'container-6xl': '',
    'container-7xl': '',
  },
  spacings: {
    'tracking-tighter': '',
    'tracking-tight': '',
    'tracking-normal': '',
    'tracking-wide': '',
    'tracking-wider': '',
    'tracking-widest': '',
    'leading-tight': '',
    'leading-snug': '',
    'leading-normal': '',
    'leading-relaxed': '',
    'leading-loose': '',
  },
  radius: {
    'radius-xs': '',
    'radius-sm': '',
    'radius-md': '',
    'radius-lg': '',
    'radius-xl': '',
    'radius-2xl': '',
    'radius-3xl': '',
    'radius-4xl': '',
  },
  shadows: {
    'shadow-2xs': '',
    'shadow-xs': '',
    'shadow-sm': '',
    'shadow-md': '',
    'shadow-lg': '',
    'shadow-xl': '',
    'shadow-2xl': '',
    'inset-shadow-2xs': '',
    'inset-shadow-xs': '',
    'inset-shadow-sm': '',
    'drop-shadow-xs': '',
    'drop-shadow-sm': '',
    'drop-shadow-md': '',
    'drop-shadow-lg': '',
    'drop-shadow-xl': '',
    'drop-shadow-2xl': '',
  },
  blurs: {
    'blur-xs': '',
    'blur-sm': '',
    'blur-md': '',
    'blur-lg': '',
    'blur-xl': '',
    'blur-2xl': '',
    'blur-3xl': '',
  },
  misc: {
    card: '',
    'card-foreground': '',
    popover: '',
    'popover-foreground': '',
    border: '',
    input: '',
    ring: '',
    'chart-1': '',
    'chart-2': '',
    'chart-3': '',
    'chart-4': '',
    'chart-5': '',
    sidebar: '',
    'sidebar-foreground': '',
    'sidebar-primary': '',
    'sidebar-primary-foreground': '',
    'sidebar-accent': '',
    'sidebar-accent-foreground': '',
    'sidebar-border': '',
    'sidebar-ring': '',
  },
  custom: {},
};

export const STARTING_STYLES = {
  colours: {
    background: '#fff',
    foreground: '#000',
    destructive: '#e4572e',
    muted: '#f7f7f7',
    'muted-foreground': '#8e8e8e',
    accent: '#f7f7f7',
    'accent-foreground': '#2e2e2e',
    primary: '#4f5cff',
    'primary-foreground': '#fcfcfc',
    secondary: '#ffe08a',
    'secondary-foreground': '#2e2e2e',
    tertiary: '#e6b17e',
    'tertiary-foreground': '#2e2e2e',
    quaternary: '#eaffea',
    'quaternary-foreground': '#2e2e2e',
    quinary: '#fffbe6',
    'quinary-foreground': '#2e2e2e',
    senary: '#ffeaf6',
    'senary-foreground': '#2e2e2e',
    septenary: '#f3eaff',
    'septenary-foreground': '#2e2e2e',
  },
  fonts: {
    'font-sans-family':
      "ui-sans-serif, system-ui, sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    'font-serif-family': "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif",
    'font-mono-family': "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    'font-weight-thin': '',
    'font-weight-extralight': '',
    'font-weight-light': '',
    'font-weight-normal': '',
    'font-weight-medium': '',
    'font-weight-semibold': '',
    'font-weight-bold': '',
    'font-weight-extrabold': '',
    'font-weight-black': '',
  },
  texts: {
    'text-xs': '',
    'text-xs--line-height': '',
    'text-sm': '',
    'text-sm--line-height': '',
    'text-base': '',
    'text-base--line-height': '',
    'text-lg': '',
    'text-lg--line-height': '',
    'text-xl': '',
    'text-xl--line-height': '',
    'text-2xl': '',
    'text-2xl--line-height': '',
    'text-3xl': '',
    'text-3xl--line-height': '',
    'text-4xl': '',
    'text-4xl--line-height': '',
    'text-5xl': '',
    'text-5xl--line-height': '',
    'text-6xl': '',
    'text-6xl--line-height': '',
    'text-7xl': '',
    'text-7xl--line-height': '',
    'text-8xl': '',
    'text-8xl--line-height': '',
    'text-9xl': '',
    'text-9xl--line-height': '',
  },
  containers: {
    'container-3xs': '',
    'container-2xs': '',
    'container-xs': '',
    'container-sm': '',
    'container-md': '',
    'container-lg': '',
    'container-xl': '',
    'container-2xl': '',
    'container-3xl': '',
    'container-4xl': '',
    'container-5xl': '',
    'container-6xl': '',
    'container-7xl': '',
  },
  spacings: {
    'tracking-tighter': '',
    'tracking-tight': '',
    'tracking-normal': '',
    'tracking-wide': '',
    'tracking-wider': '',
    'tracking-widest': '',
    'leading-tight': '',
    'leading-snug': '',
    'leading-normal': '',
    'leading-relaxed': '',
    'leading-loose': '',
  },
  radius: {
    'radius-xs': '',
    'radius-sm': '',
    'radius-md': '',
    'radius-lg': '',
    'radius-xl': '',
    'radius-2xl': '',
    'radius-3xl': '',
    'radius-4xl': '',
  },
  shadows: {
    'shadow-2xs': '',
    'shadow-xs': '',
    'shadow-sm': '',
    'shadow-md': '',
    'shadow-lg': '',
    'shadow-xl': '',
    'shadow-2xl': '',
    'inset-shadow-2xs': '',
    'inset-shadow-xs': '',
    'inset-shadow-sm': '',
    'drop-shadow-xs': '',
    'drop-shadow-sm': '',
    'drop-shadow-md': '',
    'drop-shadow-lg': '',
    'drop-shadow-xl': '',
    'drop-shadow-2xl': '',
  },
  blurs: {
    'blur-xs': '',
    'blur-sm': '',
    'blur-md': '',
    'blur-lg': '',
    'blur-xl': '',
    'blur-2xl': '',
    'blur-3xl': '',
  },
  misc: {
    card: '#ffffff',
    'card-foreground': '#262626',
    popover: '#ffffff',
    'popover-foreground': '#262626',
    border: '#ebebeb',
    input: '#ebebeb',
    ring: '#b3b3b3',
    'chart-1': '#e6b17e',
    'chart-2': '#7fd6e6',
    'chart-3': '#5e6be6',
    'chart-4': '#eaffea',
    'chart-5': '#fffbe6',
    sidebar: '#fcfcfc',
    'sidebar-foreground': '#262626',
    'sidebar-primary': '#4f5cff',
    'sidebar-primary-foreground': '#fcfcfc',
    'sidebar-accent': '#f7f7f7',
    'sidebar-accent-foreground': '#2e2e2e',
    'sidebar-border': '#ebebeb',
    'sidebar-ring': '#b3b3b3',
  },
  custom: {},
};
